import { useState } from "react";
import { useAtomValue } from "jotai";
import { Alert, AlertDescription, Button, Text } from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";
import { togglesAtomResettable } from "@zapier/canvas-state";
import styles from "./WhatsNewAlert.module.css";
import dynamic from "next/dynamic";

const DISMISSED_KEY_PREFIX = "whats-new-alert-dismissed";

function WhatsNewAlertComponent() {
  const toggles = useAtomValue(togglesAtomResettable);
  const message = toggles.show_whats_new_alert.config.message;
  const buttonText =
    toggles.show_whats_new_alert.config.buttonText || `See what's new`;
  const URL = toggles.show_whats_new_alert.config.buttonUrl;
  const imageUrl = toggles.show_whats_new_alert.config.imageUrl;
  const imageAltText = toggles.show_whats_new_alert.config.imageAltText;

  /** Use the message content as part of the key so that when the message changes,
   * the alert will show again. Each unique message gets its own dismissal state. */
  const dismissedKey = message
    ? `${DISMISSED_KEY_PREFIX}-${message.toLowerCase()}`
    : DISMISSED_KEY_PREFIX;

  const [isVisible, setIsVisible] = useState(
    !localStorage.getItem(dismissedKey),
  );

  const handleDismiss = () => {
    localStorage.setItem(dismissedKey, "true");
    setIsVisible(false);
  };

  const handleWhatsNewClick = () => {
    window.open(URL, "_blank");
    handleDismiss();
  };

  if (!isVisible || !message) {
    return null;
  }

  return (
    <div className={styles.whatsNewWrapper}>
      <Alert onDismiss={handleDismiss} status="info" variant="toast">
        <AlertDescription>
          <div className={styles.body}>
            <Text type="Body3">{message}</Text>
            {imageUrl && (
              <div className={styles.imageWrapper}>
                <img src={imageUrl} alt={imageAltText || ""} />
              </div>
            )}
            {URL && (
              <div>
                <Button
                  variant="primary"
                  size="small"
                  onPress={handleWhatsNewClick}
                  iconPosition="end"
                >
                  {buttonText}
                  <Icon name="arrowBigRight" size="small" />
                </Button>
              </div>
            )}
          </div>
        </AlertDescription>
      </Alert>
    </div>
  );
}

export const WhatsNewAlert = dynamic(
  () => Promise.resolve(WhatsNewAlertComponent),
  {
    ssr: false,
  },
);
